import { render } from "./TextGeometry.vue?vue&type=template&id=fa15bfb6"
import script from "./TextGeometry.vue?vue&type=script&lang=js"
export * from "./TextGeometry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__